import React from 'react'

const AnnouncementIcon = () => {
  return (
    <>
        <img src="/assets/announcement_icon.png" alt="Alert" className="w-[28px] h-[28px] ml-40" />
    </>
  )
}

export default AnnouncementIcon